import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "wificonfig" }

import { ref, reactive, onMounted } from 'vue';
import { useApi } from '@/hooks/useApi';
import { ElMessage, ElMessageBox, FormInstance, FormRules } from 'element-plus';
import { useBaseAsync } from 'hpsfir-managebase-ui';
import { WifiSpe } from '@/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const formRef = ref<FormInstance>();
const saving = ref(false);
const resetting = ref(false);
const loading = ref(false);

const formData = reactive<WifiSpe>({
  ssid: '',
  password: '',
});

const rules: FormRules = {
  ssid: [{ required: true, message: '请输入WiFi名称', trigger: 'blur' }],
  password: [{ required: true, message: '请输入WiFi密码', trigger: 'blur' }],
};

// 加载配置
const loadConfig = useBaseAsync(async() => {
  loading.value = true;
  try {
    const res = await useApi().wifiApi.getWifiwifi();
    const { data } = res.data;
    if (data) {
      formData.ssid = data.ssid || '';
      formData.password = data.password || '';
    }
  } finally {
    loading.value = false;
  }
});

// 保存配置
const handleSave = useBaseAsync(async() => {
  await formRef.value?.validate();
  saving.value = true;
  try {
    await useApi().wifiApi.setWifiwifi({
      wifi: formData,
    });
    ElMessage.success('保存成功');
  } finally {
    saving.value = false;
  }
});

// 重置为默认
const handleReset = async() => {
  await ElMessageBox.confirm('确定要重置为默认配置吗？', '提示', {
    type: 'warning',
    confirmButtonText: '确认',
    cancelButtonText: '取消',
  });
  resetting.value = true;
  try {
    await useApi().wifiApi.resetWifiwifi();
    ElMessage.success('重置成功');
    await loadConfig();
  } finally {
    resetting.value = false;
  }
};

onMounted(() => {
  loadConfig();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref_key: "formRef",
      ref: formRef,
      model: formData,
      rules: rules,
      "label-width": "150px",
      class: "config-form"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "WiFi名称",
          prop: "ssid"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.ssid,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.ssid) = $event)),
              placeholder: "请输入WiFi名称"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "WiFi密码",
          prop: "password"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.password) = $event)),
              placeholder: "请输入WiFi密码"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _unref(handleSave),
              loading: saving.value
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" 保存配置 ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick", "loading"]),
            _createVNode(_component_el_button, {
              onClick: handleReset,
              loading: resetting.value
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" 重置为默认 ", -1)
              ]))]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})